import { handlingCodes } from "@bitComponents/telcovid/ErrorManagementUtils";
import { WEB_SERVICES } from "../bitSagas/webServices";
import { mergeDeep } from "../utils/general";
import { WEBSERVICE_ERRORS } from "./errorCatalog";
import { FLOW_TYPES } from "../flowDefinition/flowTypes";
import { USER_TYPE } from "../bitConstants/constants";

const { NOTHINGTODO, FATAL } = handlingCodes;

const webServiceErrorHandler = {
  common: {
    [WEB_SERVICES.GET_MY_DATA]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_PRODUCT_OFFERING]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.GET_ADDRESS]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.INIT_CQ]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.SELECT_ELEMENTS]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_FEATURES]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.ADD_ITEMS_TO_CART]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.EXTEND_CQ]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.UPDATE_CQ]: {
      [`code_${WEBSERVICE_ERRORS.CLIENT_WITH_RISK}`]: {
        handlingCode: NOTHINGTODO,
      },
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.UPDATE_CA]: {
      [`code_${WEBSERVICE_ERRORS.ACCOUNT_WITH_RISK}`]: {
        handlingCode: NOTHINGTODO,
      },
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_CQ_PRICES]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_LEGAL_TERMS]: {
      [`code_${WEBSERVICE_ERRORS.CLIENT_WITH_RISK}`]: {
        handlingCode: NOTHINGTODO,
      },
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.CONFIRM_CQ]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.CANCEL_CQ]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.GET_MOBILE_INSURANCE]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.SHIPPING_TO_SE]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.UPDATE_MY_CONTACTS]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.ALLOW_ADVERTISING_USE]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.GENERATE_PIN]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.CHECK_PIN]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.CUSTOMIZER_ACTIVITY_GET_BY_NAME]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.SEND_RETARGETING]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.GET_CURRENT_DATE]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.IS_REGISTERED_SHOPPER]: {
      default: {
        handlingCode: NOTHINGTODO,
      },
    },
    [WEB_SERVICES.VALIDATE_SHOPPER]: {
      "401": {
        handlingCode: NOTHINGTODO,
      },
      "415": {
        handlingCode: NOTHINGTODO,
      },
      [`code_${WEBSERVICE_ERRORS.OTP_INCORRECT}`]: {
        handlingCode: NOTHINGTODO,
      },
      [`code_${WEBSERVICE_ERRORS.OTP_INVALID}`]: {
        handlingCode: NOTHINGTODO,
      },
      [`code_${WEBSERVICE_ERRORS.OTP_EXPIRED}`]: {
        handlingCode: NOTHINGTODO,
      },
      [`code_${WEBSERVICE_ERRORS.OTP_MAX_RETRIES_REACHED}`]: {
        handlingCode: NOTHINGTODO,
      },
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.IS_R2R_AVAILABLE_TO_PURCHASE]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_EMPLOYEES_PRODUCTS]: {
      default: {
        handlingCode: FATAL,
      },
    },
    [WEB_SERVICES.GET_AVAILABLE_EQUIPMENT]: {
      default: {
        handlingCode: FATAL,
      },
    },
  },
  flowSpec: {
    [FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS]: {
      common: {
        [WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING]: {
          default: {
            handlingCode: FATAL,
          },
        },
      },
      [`user_${USER_TYPE.TELCO}`]: {},
      [`user_${USER_TYPE.OPEN}`]: {},
    },
    [FLOW_TYPES.PACK]: {
      common: {
        [WEB_SERVICES.UPDATE_CQ]: {
          [`code_${WEBSERVICE_ERRORS.CLIENT_WITH_RISK}`]: {
            handlingCode: FATAL,
          },
          default: {
            handlingCode: FATAL,
          },
        },
        [WEB_SERVICES.GET_LEGAL_TERMS]: {
          [`code_${WEBSERVICE_ERRORS.CLIENT_WITH_RISK}`]: {
            handlingCode: FATAL,
          },
          default: {
            handlingCode: FATAL,
          },
        },
        [WEB_SERVICES.UPDATE_CA]: {
          [`code_${WEBSERVICE_ERRORS.ACCOUNT_WITH_RISK}`]: {
            handlingCode: FATAL,
          },
          default: {
            handlingCode: FATAL,
          },
        },
      },
      [`user_${USER_TYPE.TELCO}`]: {},
      [`user_${USER_TYPE.OPEN}`]: {},
    },
    [FLOW_TYPES.BONUS]: {
      common: {
        [WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING]: {
          default: {
            handlingCode: FATAL,
          },
        },
      },
      [`user_${USER_TYPE.TELCO}`]: {

      },
      [`user_${USER_TYPE.OPEN}`]: {

      },
    },
    [FLOW_TYPES.EQUIPMENT]: {
      common: {
        [WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING]: {
          default: {
            handlingCode: FATAL,
          },
        },
        [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
          [`code_${WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_2}`]: {
            handlingCode: NOTHINGTODO,
          },
          default: {
            handlingCode: FATAL,
          },
        },
      },
      [`user_${USER_TYPE.TELCO}`]: {

      },
      [`user_${USER_TYPE.OPEN}`]: {

      },
    },
  },
};

export const getSpecificErrorHanlderObj = (flowName, userType) => {
  const commonHandler = webServiceErrorHandler.common;
  let flowCommonHandler = {};
  let flowNUserTypeHanlder = {};

  if (
    webServiceErrorHandler.flowSpec &&
    webServiceErrorHandler.flowSpec[flowName]
  ) {
    if (webServiceErrorHandler.flowSpec[flowName].common) {
      flowCommonHandler = webServiceErrorHandler.flowSpec[flowName].common;
    }
    if (webServiceErrorHandler.flowSpec[flowName][`user_${userType}`]) {
      flowNUserTypeHanlder =
        webServiceErrorHandler.flowSpec[flowName][`user_${userType}`];
    }
  }

  mergeDeep(flowCommonHandler, flowNUserTypeHanlder);
  mergeDeep(commonHandler, flowCommonHandler);

  return commonHandler;
};
